import { sleep } from "../sleep";

class AnimationHandler {

    constructor(definitions = []) {
        this.actions = [
            'add',
            'remove'
        ];
        this.setDefinitions(definitions);
        this.scrollListener = null;
        this.animationTriggered = false;

        this.scrollListenerHandler = {};
        this.animationTriggeredHandler = {};
    }

    /**
     * Set definitions
     * @param {array} definitions - [{mainClass: string, classesToUse: array, startInterval: int, intervalPerAction: int, triggerAt: string|int}]
     */
    setDefinitions(definitions = []) {
        this.definitions = definitions
    }
    
    /**
     * Watches the scroll position and animates
     * @param {int} position - The scroll position in pixels to trigger the animation
     */
    watchScrollAndAnimate() {
        let index = 0;
        for (let definition of this.definitions) {
            const triggerAt = definition?.triggerAt ?? 0;
            const triggerDistance = definition?.triggerDistance ?? 20;

            let position = 0;
            if (Number.isInteger(triggerAt)) {
                position = triggerAt;
            } else {
                const el = document.querySelector(triggerAt);
                position = el ? el.getBoundingClientRect().top - this.getWindowHeight(triggerDistance) : 0;
            }


            if (position == 0) {
                if (!this.animationTriggeredHandler[index]) {
                    this.animationTriggeredHandler[index] = true;
                    this.animate();
                }
            } else {

                if (this.scrollListenerHandler[index]) {
                    window.removeEventListener('scroll', this.scrollListenerHandler[index]);
                }

                this.scrollListenerHandler[index] = () => {
                    if (window.scrollY >= position && !this.animationTriggeredHandler[index]) {

                        this.animationTriggeredHandler[index] = true;
                        this.animate();
                        window.removeEventListener('scroll', this.scrollListenerHandler[index]);
                    }
                };

                window.addEventListener('scroll', this.scrollListenerHandler[index]);

            }

            index++;
        }
    }

    /**
     * Deactivate the scroll listener
     */
    stopWatchingScroll(id = 0) {
        if (this.scrollListenerHandler[id]) {
            window.removeEventListener('scroll', this.scrollListenerHandler[id]);
            this.scrollListenerHandler[id] = null;
        }
    }

    /**
     * Activate the animation
     */
    async animate(index = 0) {
        const definition = this.definitions[index] ?? null;
        if (!definition) {
            return;
        }
        
        await sleep(parseInt(definition?.startInterval));

        const mainClass = definition?.mainClass;
        const classesToUse = definition?.classesToUse;
        const intervalPerAction = parseInt(definition?.intervalPerAction);

        const elements = document.querySelectorAll(`.${mainClass}`);

        for (let el of elements) {

            for (let thisClass of classesToUse) {
                this.handleElementClass(el, thisClass, 'add');
            }
            
            await sleep(intervalPerAction);

            for (let thisClass of classesToUse.reverse()) {
                this.handleElementClass(el, thisClass, 'remove');
            }
        }
    }

    /**
     * Performs the action to the element class
     * @param {*} element 
     * @param {*} className 
     * @param {*} action 
     */
    handleElementClass(element, className, action = null) {
        const thisAction = this.actions.includes(action) ? action : this.actions[0];

        switch (thisAction) {
            case 'add':
                element.classList.add(className);
                break;
            case 'remove':
                element.classList.remove(className);
                break;
            case 'toggle':
                element.classList.toggle(className);
                break;
        }
    }

    getWindowHeight(percentage = null) {
        const height = window.innerHeight;

        return percentage != null ? (height / 100) * percentage : height;
    }
}

export default AnimationHandler;